// extracted by mini-css-extract-plugin
module.exports = {"button":"ob_HmXNVP","regularText":"ob_cKcyrh","startIcon":"ob_J56aQO"};